export const partnerTypes = {
  individual: 11,
};
